import * as yup from 'yup'

function parseRichText(text) {
  if (text === '<p></p>') return ''
  return text
}

const letterSchema = yup.object().shape({
  name: yup.string().required('Name is required'),
  body: yup.string().transform(parseRichText).required('Content is required')
})

export { letterSchema }
